class PaymentRequired extends Error {
  constructor(message = 'Payment Required.') {
    super(message)
    this.name = this.constructor.name
    this.status = 402
    Error.captureStackTrace(this, this.constructor)
  }
}

module.exports = PaymentRequired
